import React from "react";
import LegalPageLayout, { Section } from "@/components/LegalPageLayout";
import { COMPANY } from "@/lib/company";

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy" updated={COMPANY.effectiveDate} testid="privacy-page">
      <div className="mb-8 rounded-xl border border-border bg-muted/40 p-5" data-testid="privacy-legal-entity">
        <p className="text-foreground">
          <strong>{COMPANY.brand}</strong> is a registered "doing business as" (DBA) name owned and operated by{" "}
          <strong>{COMPANY.legalName}</strong>. In this Privacy Policy, "we," "us," and "our" refer to{" "}
          {COMPANY.legalName}, doing business as {COMPANY.brand}.
        </p>
      </div>

      <Section heading="1. Who We Are">
        <p>
          {COMPANY.brand} ({COMPANY.website}) is the customer-facing brand operated by {COMPANY.legalName}, the legal
          entity responsible for this website and all related services, including winterizing signups, customer
          accounts, and communications.
        </p>
      </Section>

      <Section heading="2. Information We Collect">
        <p>
          We collect information you provide directly, such as your name, email address, phone number, mailing
          address, RV details, storage location, and service preferences, as well as account credentials and signup
          history.
        </p>
      </Section>

      <Section heading="3. How We Use Your Information">
        <p>
          We use your information to create and manage your account, process winterizing signups, provide customer
          service, and send you service-related communications (such as account activation, password resets, and
          seasonal winterizing invitations).
        </p>
      </Section>

      <Section heading="4. SMS / Text Messaging">
        <p>
          If you opt in to receive text messages, we (and our messaging providers) may send you service and
          appointment-related SMS messages. Message and data rates may apply. You can opt out at any time by replying
          STOP. We do not sell or share your mobile opt-in data or consent with third parties for their marketing.
        </p>
      </Section>

      <Section heading="5. How We Share Information">
        <p>
          We do not sell your personal information. We share information only with service providers that help us
          operate (for example, email and messaging providers), and only as needed to deliver our services or comply
          with the law.
        </p>
      </Section>

      <Section heading="6. Data Security">
        <p>
          We use industry-standard safeguards, including password hashing and encrypted connections, to protect your
          information. No method of transmission or storage is completely secure, but we work to protect your data.
        </p>
      </Section>

      <Section heading="7. Your Choices">
        <p>
          You may review and update your account information at any time from your customer dashboard, or request
          changes or deletion by contacting us.
        </p>
      </Section>

      <Section heading="8. Contact Us">
        <p>
          {COMPANY.legalName} (DBA {COMPANY.brand})
          <br />
          Email: <a href={`mailto:${COMPANY.contactEmail}`} className="text-secondary underline">{COMPANY.contactEmail}</a>
          <br />
          Website: {COMPANY.website}
        </p>
      </Section>
    </LegalPageLayout>
  );
}
